import React from 'react';
import { deleteUserAccount } from '../../api/userApi';
import '../../components/settings/AccountSetting.css'; // We'll style this below

const AccountSettings = ({ user }) => {
  console.log('Full User Object in Settings:', user);
  // Format the date for "Member Since"
  const memberSince = user.createdAt
    ? new Date(user.createdAt).toLocaleDateString('en-US', { month: 'long', year: 'numeric' })
    : 'N/A';

  const handleDelete = async () => {
    const check = prompt(
      "This will permanently delete your XP, Ranks, and Goals. Type 'DELETE' to confirm:",
    );

    if (check === 'DELETE') {
      try {
        await deleteUserAccount();
        localStorage.clear();
        window.location.href = '/login';
      } catch (err) {
        alert('Error deleting account. Please contact support.');
      }
    }
  };

  return (
    <div className="account-settings-container">
      <h2>My Account</h2>

      <div className="account-info-card">
        {/* <div className="info-row">
          <span>Membership</span>
          <span className="membership-badge">{user.progress?.currentRank || 'Standard'}</span>
        </div> */}
        <div className="info-row">
          <span>Member Since</span>
          <strong>{memberSince}</strong>
        </div>
      </div>

      <div className="danger-zone">
        <h3>Danger Zone</h3>
        <p>Once you delete your account, there is no going back. Please be certain.</p>
        <button className="delete-btn" onClick={handleDelete}>
          Delete My Account
        </button>
      </div>
    </div>
  );
};

export default AccountSettings;
